/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useState, useEffect } from 'react';
import {
    CpdsSweepstakesFormsToolkitsCheckboxLabel,
    CpdsSweepstakesFormsToolkitsHelperLabel,
    CpdsSweepstakesFormsToolkitsHelperTextWrapper,
    CpdsSweepstakesFormsToolkitsCheckboxWrapper,
    CpdsSweepstakesFormsToolkitsCheckboxContainer,
    CpdsSweepstakesFormsToolkitsCheckbox,
    CpdsSweepstakesFormsToolkitsCheckboxGost
} from '../styles/cpds-sweepstakes-forms-toolkits-inputs-style';
import { CpdsSweepstakesFormsToolkitsCheckboxProps } from '../typings';
import { Cpds } from '@Cpds.Ui';
import { widths } from '../../token/shared/common';


const Checkbox: React.FC<CpdsSweepstakesFormsToolkitsCheckboxProps> = ({
    inputId = "",
    domRef = null,
    exClasses = '',
    styleOverrides = {},
    Label = '',
    Checked = false,
    onChange = () => { },
    getValue = () => { },
    isError = false,
    isDisabled = false,
    ErrorMessage = '',
    ErrorIcon = 'information',
    ErrorIconSize = { width: '12', height: '12' },
    isOverRideTypography = false,
    clickstreamdata = '',
}) => {
    const [isChecked, setIsChecked] = useState(Checked);
    const [chkEvent, setChkEvent] = useState(null);
    useEffect(() => {
        if (getValue) {
            getValue(chkEvent);
        }
    }, [chkEvent, getValue]);

    const handleCheckboxChange = useCallback((event) => {
        if(!isDisabled){
            setIsChecked(prevIsChecked => !prevIsChecked);
            setChkEvent(event);
            if(onChange){
                onChange({
                    target: {
                        checked: !isChecked,
                        id: inputId,
                        value: !isChecked,
                    }
                });
            }
            
            if (getValue) {
                getValue(event);
            }
        }
        
    }, [onChange, getValue]);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement | HTMLUListElement>) => {
        switch (e.key) {
            case 'Spacebar':
            case ' ':
            case 'Enter':
                e.preventDefault();
                handleCheckboxChange(e);
                break;
            default:
                break;
        }
    }


    return (
        <CpdsSweepstakesFormsToolkitsCheckboxContainer
            className={`cpds-input-checkbox ${exClasses} ${isError ? 'invalid' : ''}`}
            ref={domRef}
            style={styleOverrides}
        >
            <CpdsSweepstakesFormsToolkitsCheckboxWrapper>
                <CpdsSweepstakesFormsToolkitsCheckboxGost
                    id={inputId}
                    onClick={handleCheckboxChange}
                    checked={isChecked} 
                    isDisabled={isDisabled}
                    tabIndex={0}
                    onKeyDown={handleKeyDown}
                    {...(clickstreamdata && {
                        'data-isclickstreamenabled': true,
                        'data-clickstreamdata': clickstreamdata,
                    })}
                >
                    { isChecked && <Cpds.Icon id='key-1' name='checkbox-active' customSize={{width: '16', height: '16'}}/> }
                </CpdsSweepstakesFormsToolkitsCheckboxGost>

                <CpdsSweepstakesFormsToolkitsCheckbox
                    checked={isChecked} 
                    isError={isError} 
                    isDisabled={isDisabled}
                />
                {Label && 
                <CpdsSweepstakesFormsToolkitsCheckboxLabel 
                    className="cpds-meta-roman-book-09" 
                    htmlFor={inputId}
                    isDisabled={isDisabled}
                >
                    {Label}
                </CpdsSweepstakesFormsToolkitsCheckboxLabel>}
            </CpdsSweepstakesFormsToolkitsCheckboxWrapper>

            {isError && ErrorIcon && ErrorMessage && (
                <CpdsSweepstakesFormsToolkitsHelperTextWrapper className="sweepstake-error-wrapper">
                    {ErrorIcon && <Cpds.Icon id="ico-3" color={'#C01E1E'} name={ErrorIcon} customSize={ErrorIconSize} />}
                    <CpdsSweepstakesFormsToolkitsHelperLabel 
                        isError={isError} 
                        isDisabled={false} 
                        isOverRideTypography={isOverRideTypography}
                        className="cpds-meta-roman-book-10"
                    >
                        {ErrorMessage}
                    </CpdsSweepstakesFormsToolkitsHelperLabel>
                </CpdsSweepstakesFormsToolkitsHelperTextWrapper>
            )}
        </CpdsSweepstakesFormsToolkitsCheckboxContainer>
    );
};

export default Checkbox;
